import { Col, Container, Row } from "@crehana/ui";
import { useLearnLastActivityContext, useLearnLastActivityTranslations } from "../hooks";
import ErrorMessage from "../ui/ErrorMessage";
import { jsx as _jsx } from "react/jsx-runtime";
var EnrollmentsErrorMessage = function EnrollmentsErrorMessage(_ref) {
  var onRetry = _ref.onRetry,
    withContainer = _ref.withContainer,
    dataTestId = _ref['data-testid'];
  var _useLearnLastActivity = useLearnLastActivityTranslations(),
    t = _useLearnLastActivity.t;
  var _useLearnLastActivity2 = useLearnLastActivityContext(),
    containerType = _useLearnLastActivity2.containerType,
    disableRedirections = _useLearnLastActivity2.disableRedirections,
    userDashboardUrl = _useLearnLastActivity2.userDashboardUrl,
    onGoToUserDashboard = _useLearnLastActivity2.onGoToUserDashboard,
    source = _useLearnLastActivity2.source,
    sourceDetail = _useLearnLastActivity2.sourceDetail;
  var renderErrorMessage = function renderErrorMessage() {
    return /*#__PURE__*/_jsx(Row, {
      nowrap: true,
      children: /*#__PURE__*/_jsx(Col, {
        children: /*#__PURE__*/_jsx(ErrorMessage, {
          error: t('COURSES_ERROR'),
          onRetry: onRetry,
          alternativeLink: !disableRedirections || onGoToUserDashboard ? {
            label: t('GO_TO_USER_DASHBOARD'),
            url: !disableRedirections ? userDashboardUrl : undefined,
            onClick: disableRedirections && onGoToUserDashboard ? function () {
              return onGoToUserDashboard({
                source: source,
                sourceDetail: sourceDetail
              });
            } : undefined
          } : undefined,
          "data-testid": dataTestId
        })
      })
    });
  };
  if (withContainer) {
    return /*#__PURE__*/_jsx(Container, {
      type: containerType,
      children: renderErrorMessage()
    });
  }
  return renderErrorMessage();
};
export default EnrollmentsErrorMessage;